import { isHSBCInstance } from '@ben/orion/utils/sub-domain';

export const fsMaskForHSBCInstance = isHSBCInstance ? 'fs-mask' : undefined;
